// extracted by mini-css-extract-plugin
var _1 = "Menu-moduleMenu__FuUyF";
var _2 = "Menu-modulecollapsed__mikSp";
var _3 = "Menu-modulecontent__a2JEs";
var _4 = "Menu-moduleexpanded__Pyvww";
var _5 = "Menu-modulelogo__iaKyw MenuLogo-moduleMenuLogo__TINry CompanyLink-moduleCompanyLink__jbr98";
var _6 = "Menu-moduleprimary___cepv PrimaryMenu-modulePrimaryMenu__zPqXY MenuItems-moduleMenuItems__Km6SD";
var _7 = "Menu-modulesecondary___SQRT SecondaryMenu-moduleSecondaryMenu__sTwFH MenuItems-moduleMenuItems__Km6SD";
export { _1 as "Menu", _2 as "collapsed", _3 as "content", _4 as "expanded", _5 as "logo", _6 as "primary", _7 as "secondary" }
